export const navigateWithQr = (
    navigate: any,
    pathname: string,
    targetPath: string,
    options?: any
) => {
    const match = pathname.match(/^\/qrcode\/([^/]+)/);

    if (match) {
        navigate(`/qrcode/${match[1]}${targetPath}`, options);
    } else {
        navigate(targetPath, options);
    }
};